export default [
  {
    motive: 'project.installation.site',
  },
  {
    motive: 'materials.constructive.method.used',
  },
  {
    motive: 'ventilation.systems.and.indoor.air.treatment',
  },
  {
    motive: 'project.installation.site',
  },
  {
    motive: 'materials.constructive.method.used',
  },
  {
    motive: 'definitive.noise.or.vibration.control.elements',
  },
  {
    motive: 'project.installation.site',
  },
  {
    motive: 'materials.constructive.method.used',
  },
  {
    motive: 'retention.elements.or.soil.restoration.treatments',
  },
  {
    motive: 'materials.constructive.method.used',
  },
  {
    motive: 'materials.constructive.method.used',
  },
  {
    motive: 'project.installation.site',
  },
  {
    motive: 'corrective.measures',
  },
  {
    motive: 'closures.diversions.during.execution.work',
  },
  {
    motive: 'materials.construction.method',
  },
];
